const ROUTES = [
    '/?brands/?', // Matches exactly /brands/
    '/?brands/.*', // Matches all sub-paths under /brands/
    '/?preferred/?',
    '/?preferred/.*',
    '/?agents/?',
    '/?agents/.*',
    '/?workspace/?',
    '/?workspace/.*',
    '/?learn/?',
    '/?learn/.*',
    '/?news/?',
    '/?news/.*',
    '/?buy/new/?',
    '/?buy/integrated-services/?',
    '/?buy/homebuying-coach/?',
    '/?buy/join-homebuying-coach/?',
    '/?buy/rewards/?',
    '/?buy/join-rewards/?',
    '/?buy/rewards-fs/?',
    '/?buy/join-rewards-fs/?',
    '/?buy/rewards-fs-fr/?',
    '/?buy/join-rewards-fs-fr/?',
    '/?buy/foyer-homebuyer-savings/?',
    '/?buy/foyer-homebuyer-agent/?',
    '/?buy/foyer-renter-exclusive-offer/?',
    '/?buy/?',
    '/?careers/?', // Matches exactly /careers/
    '/?careers/.*', // Matches all sub-paths under /careers/
    '/?corporate/?',
    '/?corporate/.*',
    '/?sell/?', // Matches exactly /sell/
    '/?sell/.*', // Matches all sub-paths under /sell/
    '/?sell/public-home-listings/?',
    '/?sell/seller-resources/?',
    '/?homeloans/?', // Matches exactly /homeloans/
    '/?homeloans/.*', // Matches all sub-paths under /homeloans/
    '/?homeloans/buyability/.*',
    '/?homeloans/new/?',
    '/?new-construction-advertising/?', // Matches exactly /new-construction-advertising/
    '/?new-construction-advertising/.*', // Matches all sub-paths under /new-construction-advertising/
    // Matches any path that starts with /listing-contact-form/
    '/?listing-contact-form/.*',
    '/?listing-contact-form/?',
    '/?product-releases/?', // Matches exactly /product-releases/
    '/?product-releases/.*', // Matches all sub-paths under /product-releases/
    '/?rent/.*', // Matches all sub-paths under /rent/
    '/?rental-manager/?', // Matches exactly /rental-manager/
    '/?rental-manager/collect-rent-online/?', // Matches exactly /rental-manager/collect-rent-online/
    '/?rental-manager/post-a-listing/?', // Matches exactly /rental-manager/post-a-listing/
    '/?rental-manager/price-my-rental/?', // Matches exactly /rental-manager/price-my-rental/
    '/?rental-manager/rental-lease-agreements/?', // Matches exactly /rental-manager/rental-lease-agreements/
    '/?rental-manager/tenant-screening/?', // Matches exactly /rental-manager/tenant-screening/
    '/?rentals-network/?', // Matches exactly /rentals-network/
    '/?rentals-network/ai-assist/?', // Matches exactly /rentals-network/ai-assist/
    '/?rentals-network/claim-your-multifamily-listings/?', // Matches exactly /rentals-network/claim-your-multifamily-listings/
    '/?rentals-network/lease-connect/?', // Matches exactly /rentals-network/lease-connect/
    '/?rentals-network/listing-feeds/?', // Matches exactly /rentals-network/listing-feeds/
    '/?rentals-network/multifamily-listings/?', // Matches exactly /rentals-network/multifamily-listings/
    '/?rentals-network/packages/?', // Matches exactly /rentals-network/packages/
    '/?rentals-network/rental-advertising/?', // Matches exactly /rentals-network/rental-advertising/
    '/?zestimate/?', // Matches exactly /zestimate/
    '/?mls-disclaimers/?', // Matches exactly /mls-disclaimers/
    '/?today/?', // Matches exactly /today/
    '/?today/.*', // Matches all sub-paths under /today/
    '/?warcraft/?', // Matches exactly /warcraft/
    '/?warcraft/.*', // Matches all sub-paths under /warcraft/
    '/?zillow-closing/?', // Matches exactly /zillow-closing/
    '/?zillow-closing/.*', // Matches all sub-paths under /zillow-closing/
];

/**
 * Safely parses pathname from asPath with error handling
 */
export function parsePathname(asPath) {
    try {
        return new URL(asPath, 'http://dummy.base').pathname;
    } catch (error) {
        return asPath || '/';
    }
}

export function shouldUseVisualRefreshTheme(pathname, query = {}) {
    // Normalize pathname once
    const p = pathname?.toLowerCase() || '';

    // Special case for preview - only use visual refresh if explicitly requested via query param
    if (p.includes('/preview/') && query?.useVisualRefresh !== undefined) {
        const useVisualRefreshParam = Array.isArray(query.useVisualRefresh)
            ? query.useVisualRefresh[0]
            : query.useVisualRefresh;
        // Handle both boolean and string values
        return (
            useVisualRefreshParam === true || useVisualRefreshParam === 'true'
        );
    }

    const regex = new RegExp('^(?:' + ROUTES.join('|') + ')$');
    return regex.test(p);
}

const _zconfigs = {
    prod: {
        serverURLs: {
            MAX: 'https://mortgageapi.zillow.com',
        },
        partnerId: 'RD-WXDQSGN',
    },
    default: {
        serverURLs: {
            MAX: 'https://mortgageapi.qa.zillow.net',
        },
        partnerId: 'RD-GKZRBBL',
    },
};

export function getZmAPIConfig() {
    return _zconfigs[process.env.NEXT_PUBLIC_ENV] || _zconfigs.default;
}
